import {Component, Input, OnInit} from '@angular/core';
import {EventItem, Lookups} from "@model";
import {OrganiserContactModalComponent, ShareModalComponent} from "@components";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-event-contacts-tab',
  templateUrl: './event-contacts-tab.component.html',
  styleUrls: ['./event-contacts-tab.component.scss']
})
export class EventContactsTabComponent implements OnInit {
  @Input() event: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  mediaVideoHor: string | undefined;
  mediaVideoVert: string | undefined;

  constructor(private modalService: NgbModal) {
  }

  isEventItem(item: any): item is EventItem {
    return item && 'phoneNumbers' in item;
  }

  ngOnInit(): void {
    this.makeLinksEmbeddable();
  }

  makeLinksEmbeddable() {
    if (this.makeLinkEmbeddable(this.event?.mediaContentVideoHor)) {
      this.mediaVideoHor = 'https://www.youtube.com/embed/' + this.makeLinkEmbeddable(this.event?.mediaContentVideoHor);
      this.videoHorLinkIsValid();
    }
    if (this.makeLinkEmbeddable(this.event?.mediaContentVideoVert)) {
      this.mediaVideoVert = 'https://www.youtube.com/embed/' + this.makeLinkEmbeddable(this.event?.mediaContentVideoVert);
      this.videoVertLinkIsValid();
    }
  }

  getLabel() {
    return true;
  }

  makeLinkEmbeddable(link: string | undefined): string | undefined {
    const regex1: RegExp = /[?&]v=([^&#]*)/;
    const regex2: RegExp = /\/shorts\/([^\/?]+)/;
    const match1: RegExpMatchArray | null | undefined = link?.match(regex1);
    const match2: RegExpMatchArray | null | undefined = link?.match(regex2);
    if (match1) {
      return match1 ? match1[1] : undefined;
    }
    if (match2) {
      return match2 ? match2[1] : undefined;
    }
    return undefined;
  }

  videoHorLinkIsValid(): boolean {
    var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return !!this.mediaVideoHor?.match(p);
  }

  videoVertLinkIsValid(): boolean {
    var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return !!this.mediaVideoVert?.match(p);
  }

  openContactOrganiserModal() {
    const modalRef =  this.modalService.open(OrganiserContactModalComponent, {
      centered: true,
      windowClass: 'contacts-modal',
    });
    modalRef.componentInstance.currentItem = this.event;
  }

  openShareModal() {
    const modalRef: NgbModalRef = this.modalService.open(ShareModalComponent, {
      centered: true,
      windowClass: 'share-modal'
    });
    modalRef.componentInstance.languages = this.languages;
    modalRef.componentInstance.eventItem = this.event;
    modalRef.componentInstance.isShareVisible = true;
  }
}
